'use client'

import useEnquiry from '@hooks/useEnquiry'
import { useBoolean } from 'react-use'

export function PhoneButton({
  data
}) {

  // 是否显示电话
  const [showPhone, setShowPhone] = useBoolean(false)
  return (
    <a href={`tel:${data.phone}`} data-noprogress className='w-full button-primary-out sm:w-180' onClick={() => setShowPhone(true)}>
      <i className='icon icon-phone'></i>
      <span className='ml-10'>{showPhone ? data.phone : 'Call'}</span>
    </a>
  )
}

export function EmailButton({
  data
}) {

  const { showBuilderEnquiry } = useEnquiry()
  return (
    <button type='button' className='w-full button-primary sm:w-180' onClick={showBuilderEnquiry({ builder: data })}>
      <i className='icon icon-email'></i>
      <span className='ml-10'>Email</span>
    </button>
  )
}